module.exports = __webpack_public_path__ + "img/WASHER_AMENITY.23a30bab.svg";